import { styled, css } from 'styled-components';

import { StyledVersionedRouterLink } from '#/components/Link/StyledVersionedRouterLink';
import { cssBreakpoints } from '#/theme/theme';

export const StyledRouterLink = styled(StyledVersionedRouterLink)`
  overflow-wrap: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// TODO: simplify and use flex w. gap, once we drop
// the Box component which doesn't support it.
// Replacing Box or updating styled-system
// could fix the issue, but is likely to introduce regressions.
// FYI Box does support a gridGap prop, but both are deprecated.
export const Separator = styled.div`
  margin-inline-end: 10px;
`;

export const LinkContainer = styled.div`
  display: flex;
  margin-inline-end: 10px;

  &:last-child {
    min-width: 0;
  }
`;

export const BreadcrumbsBackLinkOnlyHolder = styled.div`
    @media screen and (min-width: ${cssBreakpoints.mdUp}) {
        display: none;
    }
`;

export const BreadcrumbsAllLinksHolder = styled.div<{
  $noBackLink: boolean;
}>`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    line-height: 1.5;

    ${(props) =>
      !props.$noBackLink &&
      css`
          @media screen and (max-width: ${cssBreakpoints.mdDown}) {
              display: none;
          }
      `};
`;
